import React from 'react';
import { StoreProvider } from './src/context/StoreContext';
import '@fontsource/manrope';

export const wrapRootElement = ({ element }) => (
  <StoreProvider>{element}</StoreProvider>
);
